/**
 * Four-point cubic Hermite (Catmull-Rom).
 *
 * Note the shape: the coefficients c0..c3 are four fixed FIR branches over the
 * same four taps, combined by Horner in mu. That *is* a Farrow structure — this
 * kernel and `farrow-4` are the same filter, arranged differently, and they
 * measure identically. Farrow is the implementation pattern, not a rival to it.
 */
export function readHermite(w, i, mu) {
  const xm1 = w[i - 1];
  const x0 = w[i];
  const x1 = w[i + 1];
  const x2 = w[i + 2];

  const c0 = x0;
  const c1 = 0.5 * (x1 - xm1);
  const c2 = xm1 - 2.5 * x0 + 2 * x1 - 0.5 * x2;
  const c3 = 0.5 * (x2 - xm1) + 1.5 * (x0 - x1);

  return ((c3 * mu + c2) * mu + c1) * mu + c0;
}

export const HERMITE = {
  id: "hermite",
  label: "Cubic Hermite (4-tap)",
  kernel: "hermite",
  taps: 4,
  before: 1,
  after: 2,
  notes: "Catmull-Rom. Big step up from linear for very little; distinct from Lagrange-4 but measures the same.",
  buildTable: () => null,
  params: { taps: 4 },
};
